import React from 'react';
import PropTypes from 'prop-types';
import * as Headless from '@headlessui/react';
import clsx from 'clsx';

/**
 * A component that renders a description element.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the description.
 * @param {Object} [props.children] - Child elements to be rendered inside the description.
 * @returns {JSX.Element} The rendered description component.
 */
export function Description({ className, ...props }) {
  return (
    <Headless.Description
      data-slot="description"
      {...props}
      className={clsx(
        className,
        'text-base/6 text-zinc-500 data-[disabled]:opacity-50 sm:text-sm/6'
      )}
    />
  );
}

Description.propTypes = {
  className: PropTypes.string,
};
